// src/views/reports/ReportRevenueDistribution.jsx

import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Menu from "../../components/Menu.js";
import {
  Button,
  Table,
  Card,
  Badge,
  Spinner,
  Alert,
  Image,
} from "react-bootstrap";
import api from "../../api.js";
import "../componentCss/ReportRevenueDistributionItem.css";

// Observe que aqui você importa somente o DownloadButton
import DownloadButton from "../../components/DownloadButtonReportConsultEmergency.js";

const ConsultTransferItem = () => {
  const navigate = useNavigate();
  const { id: idParam } = useParams();

  const [payment, setPayment] = useState(null);
  const [professionals, setProfessionals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [totalProcedures, setTotalProcedures] = useState(0);

  // Formata para BRL
  const formatCurrency = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value || 0);
  };

  useEffect(() => {
    setTotalProcedures(data.length);
    console.log("Profissionais:", data);
    console.log("payment", payment);
  }, [data]);

  // Formata data
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("pt-BR");
  };

  // Formata mês do tipo YYYY-MM
  const formatMonth = (monthString) => {
    if (!monthString) return "";
    if (monthString.match(/^\d{4}-\d{2}$/)) {
      const [year, month] = monthString.split("-");
      const date = new Date(year, parseInt(month) - 1, 1);
      return date.toLocaleString("pt-BR", { month: "long", year: "numeric" });
    }
    return monthString;
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const paymentResponse = await api.get(
          `/api/fund-executing-transfers/cashbox/${idParam}`
        );
        console.log("Vindo da req: ", paymentResponse.data);
        setData(paymentResponse.data);
      } catch (err) {
        console.error("Error loading data:", err);
        setError("Erro ao carregar os dados. Por favor, tente novamente.");
        setLoading(false);
      }
    };
    fetchData();
  }, [idParam]);

  useEffect(() => {
    if (!Array.isArray(data)) return;

    const formatted = data.reduce((acc, item) => {
      const existing = acc.find((i) => i.name === item.executing_company);

      const valueToAdd = parseFloat(item.procedure_value || 0);

      if (existing) {
        existing.procedures += 1;
        existing.value += valueToAdd;
      } else {
        acc.push({
          id: item.id,
          name: item.executing_company,
          procedures: 1,
          value: valueToAdd,
          customer_name: item.customer_name,
        });
      }

      return acc;
    }, []);

    setProfessionals(formatted);
  }, [data]);

  // Carrega os dados do repasse
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const paymentResponse = await api.get(`/api/fund-transfers/${idParam}`);
        setPayment(paymentResponse.data.data);

        // Se quiser, também carregaria a lista de professionals do backend aqui

        // Exemplo de total de procedures
        // const totalProcs = professionalsResponse.data.reduce(
        //   (sum, prof) => sum + (prof.procedures || 0),
        //   0
        // );
        // setTotalProcedures(totalProcs);

        setLoading(false);
      } catch (err) {
        console.error("Error loading data:", err);
        setError("Erro ao carregar os dados. Por favor, tente novamente.");
        setLoading(false);
      }
    };

    fetchData();
  }, [idParam]);

  if (loading) {
    return (
      <Menu
        screen={
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "80vh" }}>
            <Spinner animation="border" variant="primary" />
            <span className="ml-2">Carregando dados...</span>
          </div>
        }
      />
    );
  }

  if (error) {
    return (
      <Menu
        screen={
          <div className="alert alert-danger m-4">
            <h4>Erro</h4>
            <p>{error}</p>
            <Button
              variant="outline-danger"
              onClick={() =>
                navigate("/financial/revenue-distribution-consult-emergency")
              }>
              Voltar
            </Button>
          </div>
        }
      />
    );
  }

  if (!payment) {
    return (
      <Menu
        screen={
          <div className="alert alert-warning m-4">
            <h4>Dados não encontrados</h4>
            <p>Não foi possível encontrar os dados do repasse solicitado.</p>
            <Button
              variant="outline-warning"
              onClick={() =>
                navigate("/financial/revenue-distribution-consult-emergency")
              }>
              Voltar
            </Button>
          </div>
        }
      />
    );
  }

  const screenContent = (
    <div className="report-revenue-container p-4">
      <Card className="mb-4">
        <Card.Header className="d-flex justify-content-between align-items-center text-black">
          <h3 className="m-0">Controle de Distribuição de Receita</h3>
          <Badge bg="light" text="dark" pill>
            ID: {payment.id}
          </Badge>
        </Card.Header>
        <Card.Body>
          <div className="row">
            <div className="col-md-6">
              <h4>Detalhes do Repasse</h4>
              <Table bordered hover responsive className="mt-3">
                <tbody>
                  <tr>
                    <td>
                      <strong>Valor Total</strong>
                    </td>
                    <td>{formatCurrency(payment.total_amount)}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Período</strong>
                    </td>
                    <td>
                      {formatDate(payment.start_date)} a{" "}
                      {formatDate(payment.end_date)}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Mês de Repasse</strong>
                    </td>
                    <td>{formatMonth(payment.transfer_month)}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Procedimentos</strong>
                    </td>
                    <td>{totalProcedures}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Data de Criação</strong>
                    </td>
                    <td>{formatDate(payment.created_at)}</td>
                  </tr>
                </tbody>
              </Table>
              <div>
                <h4>Relatório</h4>
                <div className="border p-3 rounded mt-3">
                  {/*
                   * Aqui chamamos o botão que gera o PDF,
                   * passando os dados necessários
                   */}
                  <DownloadButton dataPayments={payment} professionals={data} />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <h4>Descrição</h4>
              <div
                className="border p-3 rounded mt-3"
                style={{ minHeight: "100px" }}>
                {payment.description || "Nenhuma descrição disponível"}
              </div>

              {payment.photo && (
                <div className="mt-3">
                  <h4>Comprovante</h4>
                  <div className="text-center border p-2 rounded">
                    <a
                      href={payment.photo}
                      target="_blank"
                      rel="noopener noreferrer"
                      download>
                      <Image
                        src={payment.photo}
                        alt="Comprovante de repasse"
                        thumbnail
                        style={{ maxHeight: "100px" }}
                      />
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12">
              <Card className="bg-light">
                <Card.Body className="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="mb-0">Resumo de Pagamentos</h4>
                    <p className="text-muted mb-0">
                      Total de Consultas: {professionals?.length}
                    </p>
                  </div>
                  <div className="d-flex align-items-center">
                    <div className="text-center">
                      <h5>Valor Total Pago</h5>
                      <Badge
                        bg="success"
                        style={{ fontSize: "1.2rem", padding: "10px 15px" }}>
                        {formatCurrency(payment.total_amount)}
                      </Badge>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
        </Card.Body>
      </Card>

      <Card>
        <Card.Header className="text-black">
          <h4 className="m-0">Consultas</h4>
        </Card.Header>

        <Card.Body>
          {professionals.length === 0 ? (
            <Alert variant="info">
              Nenhum profissional encontrado para este repasse.
            </Alert>
          ) : (
            <Table striped bordered hover responsive>
              <thead className="bg-light">
                <tr>
                  <th>Nome</th>
                  <th>Cliente</th>
                  <th>Valor</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {professionals.map((professional) => (
                  <tr key={professional.id}>
                    <td>{professional.name || "N/A"}</td>
                    <td className="text-center">
                      {professional.customer_name || "N/A"}
                    </td>
                    <td>{formatCurrency(professional.value)}</td>
                    <td>
                      <Badge bg="success">Pago</Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
      <div className="mt-3">
        <Button
          variant="secondary"
          onClick={() =>
            navigate(`/financial/revenue-distribution-consult-emergency`)
          }>
          Voltar
        </Button>
      </div>
    </div>
  );

  return <Menu screen={screenContent} />;
};

export default ConsultTransferItem;
